module.exports = __webpack_public_path__ + "static/media/Luqmaan_CV.3bc05466.pdf";